import {Layers, RockBottomLayers, SimpleStageLayer} from "../../view/RockBottomLayers";
import {gsap} from "gsap";
import {RockBottom} from "../../RockBottom";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {IBetWayWinData} from "../../server/data/IRockBottomData";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {RockBottomGameConfig} from "../../RockBottomGameConfig";
import {RockBottomGameAssets} from "../../RockBottomGameAssets";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {RockBottomSymbol} from "../../symbol/RockBottomSymbol";
import {RockBottomGameMode} from "../../server/RockBottomGameMode";

export class NJReqWinView extends PIXI.Container {
    private _layer: SimpleStageLayer | undefined;

    constructor() {
        super();

        this.init();
    }

    public showWinAndWays(durr: number): gsap.core.Timeline {
        const winPosArray: number[][] = [],
            gameData: RockBottomParsedGameData = RockBottom.model.parsedGameData,
            tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    this.removeChildren();
                }
            });

        let delayOffset: number = 0;

        for (let i: number = 0; i < gameData.betWins.length; i++) {
            const winData: IBetWayWinData = <IBetWayWinData>gameData.betWins[i],
                winWrapper: PIXI.Container = this.createBetWinView(winData),
                reelIdxBuffer: number = ((gameData.mode === RockBottomGameMode.FREESPIN) || (gameData.mode === RockBottomGameMode.SUPER_FREESPIN) || (gameData.mode === RockBottomGameMode.FREESPIN_SUPER)) ? 0 : 1,
                reelId: number = (winData.length - reelIdxBuffer),
                currPosArray: number[] = [reelId, winData.reelWinPositions[reelId].lastIndexOf(true)],
                isAtSameSymbol: boolean = winPosArray.some(innerArray =>
                    innerArray.length === currPosArray.length && innerArray.every((value, index) => value === currPosArray[index])
                );

            if (isAtSameSymbol) {
                delayOffset += 0.15;
            } else {
                delayOffset = 0;
            }

            winPosArray[i] = currPosArray;

            this.addChild(winWrapper);

            tl.add(() => {
                winWrapper.alpha = 1;
            }, delayOffset);
            tl.to(winWrapper, {y: winWrapper.position.y - 90, duration: durr}, delayOffset);
            tl.to(winWrapper, {
                alpha: 0,
                duration: durr - (durr / 1.5)
            }, (delayOffset + (durr / 1.5)));
        }

        return tl;
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.WIN_COUNT_UP);
        this._layer?.addChildAt(this, 0);
        this.position.set(0, -20);
    }

    private createBetWinView(winData: IBetWayWinData): PIXI.Container {
        const wrapper: PIXI.Container = new PIXI.Container(),
            countUp: BitmapCountUp = this.createCountUp(winData.multipliedAmount),
            waysText: PIXI.Text = this.createWaysText(winData.numberOfCombinations),
            reelIdxBuffer: number = ((winData.mode === RockBottomGameMode.FREESPIN) || (winData.mode === RockBottomGameMode.SUPER_FREESPIN) || (winData.mode === RockBottomGameMode.FREESPIN_SUPER)) ? 0 : 1,
            reelId: number = winData.length - reelIdxBuffer,
            symId: number = winData.reelWinPositions[reelId].lastIndexOf(true),
            lastWinSym: RockBottomSymbol = RockBottom.reels[reelId].getSymbol(symId);

        wrapper.name = winData.symbol;
        wrapper.alpha = 0;
        wrapper.position = lastWinSym.getGlobalPosition();

        wrapper.addChild(countUp, waysText);

        return wrapper;
    }

    private createCountUp(amount: number): BitmapCountUp {
        const countUp: BitmapCountUp = new BitmapCountUp({
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 15,
            letterSpacing: -15
        });
        countUp.maxTextWidth = RockBottomGameConfig.SYMBOL_WIDTH;
        countUp.shrinkSize = true;
        countUp.getCountUpAnimation(amount, amount, 0.001);

        return countUp;
    }

    private createWaysText(waysCount: number): PIXI.Text {
        const wayOrWaysStr: string = waysCount + " " + RockBottom.apiPlugin.translations.translate(waysCount === 1 ? "Way Won" : "Ways Won"),
            text: PIXI.Text = new PIXI.Text(wayOrWaysStr, {
                fill: 0xffffff,
                fontFamily: OpenSans.FAMILY,
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 15,
                stroke: 0x000000,
                strokeThickness: 5,
                lineJoin: "round"
            });

        text.anchor.set(0.5);
        text.position.set(0, 50);

        return text;
    }
}